import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import Swal from 'sweetalert2';

const PinTable = ({ pinsData, submittedemailId }) => (
  <table className="table table-bordered text-nowrap mb-0">
    <thead>
      <tr>
        <th>Sl NO</th>
        <th>PIN</th>
        <th>Status</th>
        <th>User ID</th>
      </tr>
    </thead>
    <tbody>
      {pinsData.map((pin, index) => (
        <tr key={index}>
          <td>{pin.id}</td>
          <td>{pin.pin}</td>
          <td>{pin.status}</td>
          <td>{pin.userId || submittedemailId}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

const FreePingenration = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [pinsData, setPinsData] = useState([]);
  const [submittedemailId, setSubmittedemailId] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pinCount, setPinCount] = useState(1); 
  const [count, setCount] = useState(0);
  const itemsPerPage = 10;

  const activePins = pinsData.filter((pin) => pin.status === 'active');
  const usedPins = pinsData.filter((pin) => pin.status === 'used');

  useEffect(() => {
    fetchPinsData();
  }, []);

  const fetchPinsData = async () => {
    try {
      const response = await axios.get('https://apimlm.bloomitsolutions.in/ferrpinrotes/getAllPinsHandler');
      const data = response.data.pins;

      if (Array.isArray(data)) {
        setPinsData(data);
        setCount(data.length);
      } else {
        console.error('API did not return an array:', data);
      }
    } catch (error) {
      console.error('Error fetching pins data:', error);
    }
  };

  const handleSubmit = async () => {
    if (email.trim() === '') {
      setError('Please enter an Email ID');
    } else if (pinCount < 1) {
      setError('Please enter a valid Pin Count (greater than or equal to 1)');
    } else {
      setError('');
  
      // Check if the user has already generated 10 PINs with the entered email.
      const pinCountForEmail = pinsData.filter((pin) => pin.userId === email).length;
      if (pinCountForEmail + pinCount > 10) {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'You have exceeded the maximum allowed PINs (10) for this Email ID.',
        });
      } else {

        try {

          const generatedPins = [];
          for (let i = 0; i < pinCount; i++) {
            const response = await axios.post('https://apimlm.bloomitsolutions.in/ferrpinrotes/generate-pin', { email });
            generatedPins.push(response.data);
          }

          setPinsData([...pinsData, generatedPins]);
          setCount(count + pinCount);
          setEmail('');
          setPinCount(1);
  
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Email and PIN stored successfully.',
          });
        } catch (error) {
          console.error('Error generating free PIN:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to generate the PIN. Please try again later.',
          });
        }
      }
    }
  };
  

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = pinsData.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    if (currentPage < Math.ceil(pinsData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div>
      <div className="col-lg-6 m-5">
        <div className="card border-0 shadow">
          <div className="card-header bg bg-info border-0">
            <h4>Generate Free PIN</h4>
          </div>

          <div className="card-body">
            <div className="col-lg-12">
              <label htmlFor="exampleInputPassword1" className="form-label">
                Email ID
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email ID"
                id="exampleInputPassword1"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {error && <p className="text-danger">{error}</p>}
            </div>

            <div className="col-lg-12 mt-3">
        <label htmlFor="pinCount" className="form-label">
          Pin Count
        </label>
        <input
          type="number"
          className="form-control"
          id="pinCount"
          value={pinCount}
          onChange={(e) => setPinCount(Number(e.target.value))}
        />
      </div>
      
            <div className="col-lg-12 mt-3">
              <button className="btn btn-primary mt-1 mx-2" onClick={handleSubmit}>
                Submit
              </button>
              <button className="btn btn-secondary mx-2 mt-1">
                Count: {pinCount}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="row mx-2">
        <div className="col-md-12 col-lg-12 col-xl-12 mt-4">
          <div className="card">
            <div className="card-header bg bg-dark">
              <h4 className="text-white">PINs Details</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <PinTable pinsData={currentItems} submittedemailId={submittedemailId} />
              <nav aria-label="...">
                <ul className="pagination mt-4">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={prevPage}>Previous</button>
                  </li>
                  {Array.from({ length: Math.ceil(pinsData.length / itemsPerPage) }).map((_, index) => (
                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(index + 1)}>
                        {index + 1}
                      </button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === Math.ceil(pinsData.length / itemsPerPage) ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={nextPage}>Next</button>
                  </li>
                </ul>
              </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreePingenration;
